import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { API_BASE_URL } from '../utils/apiConfig';

const Blogs = () => {
  const [blogs, setBlogs] = useState([]);
  const [currentPage, setCurrentPage] = useState(() => {
    return parseInt(localStorage.getItem('currentPage')) || 1;
  });
  const [totalPages, setTotalPages] = useState(1);

  const limit = 5;

  useEffect(() => {
    fetch(`${API_BASE_URL}/blogs?page=${currentPage}&limit=${limit}`) 
      .then(res => res.json())
      .then(data => {
        // console.log('Fetched blog list:', data);
        // console.log('Fetched blog list:', data[0].tags);
        // console.log('Tags:', data[0].tags, typeof data[0].tags);
        setBlogs(Object.values(data).filter(item => item.id));
        setTotalPages(Math.ceil(data.totalQuery.total / limit));
      })
      .catch(err => console.error(err));
  }, [currentPage]);

  const handlePageChange = (page) => {
    // if (page < 1 || page > totalPages) return;
    // setCurrentPage(page);
    setCurrentPage(page);
    localStorage.setItem('currentPage', page);
  };


  if (!blogs) return <div className="blogs-grid"><p className='blogs-title'>Loading...</p></div>;

  return (
    <>
      <div className="blogs-grid">

        {blogs.map((article, index) => (
          <Link to={"/blog/" + article.id} className="blogs-card-link" key={index}>
            <div className="blogs-card">
              <img src={article.image} alt={article.title} className="blogs-card-img" />
              <div className="blogs-tags">
                {/* {article.tags && Object.values(article.tags).map((tag, tagIndex) => (
                  <div className="blogs-tag" key={tagIndex}>{tag}</div>
                )) } */}

                {Array.isArray(article.tags) ? (
                  article.tags.map((tag, tagIndex) => (
                    <div className="blogs-tag" key={tagIndex}>{tag}</div>
                  ))
                ) : (
                  <div className="blogs-tag">No tags</div>
                )}

                {/* <div className="blogs-tag">{article.tag}</div>
                <div className="blogs-tag">{article.tag}</div>
                <div className="blogs-tag">{article.tag}</div> */}
              </div>

              <h3 className="blogs-title">{article.title}</h3>
              <p className="blogs-preview">{article.short_description}</p>
              <div className="blogs-footer">
                <span className="blogs-author">{article.full_name}</span>
                <span className="blogs-date">{article.blog_created}</span>
              </div>
            </div>
          </Link>
        ))}
      </div>

      <div className="blogs-pagination">
        <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>{'<'}</button>

        <button
          className={currentPage === 1 ? 'blogs-active' : ''}
          onClick={() => handlePageChange(1)}
        >
          1
        </button>

        {currentPage > 3 && <span>...</span>}

        {currentPage > 2 && currentPage < totalPages - 1 && (
          <button
            className="blogs-active"
            onClick={() => handlePageChange(currentPage)}
          >
            {currentPage}
          </button>
        )}

        {currentPage < totalPages - 2 && <span>...</span>}

        {totalPages > 1 && (
          <button
            className={currentPage === totalPages ? 'blogs-active' : ''}
            onClick={() => handlePageChange(totalPages)}
          >
            {totalPages}
          </button>
        )}

        <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>{'>'}</button>
      </div>
    </>
  )
}

export default Blogs